export const initLimitButtonLength = () => {
  const buttons = document.querySelectorAll('[data-link-button]');
  if (!buttons.length) {
    return;
  }
  buttons.forEach((button) => {
    const btnSpan = button.querySelector('span');
    if (!btnSpan) {
      return;
    }
    const text = btnSpan.textContent;
    if (text.length > 30) {
      btnSpan.textContent = text.slice(0, 30) + '...';
    }
  });
};
